export default __webpack_public_path__ + "static/media/banana-bnb.4b4da912.svg";